import { render, staticRenderFns } from "./SalePricesUnitDetail.vue?vue&type=template&id=03bf9f3e&scoped=true"
import script from "./SalePricesUnitDetail.vue?vue&type=script&lang=js"
export * from "./SalePricesUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./SalePricesUnitDetail.vue?vue&type=style&index=0&id=03bf9f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf9f3e",
  null
  
)

export default component.exports